import { black, green, red, yellow } from 'globals/colors';
import { ReportStatus } from 'globals/types';

export const getColor = (type: ReportStatus): string => {
  switch (type) {
    case ReportStatus.READY:
      return green.MAIN;
    case ReportStatus.BROKEN:
      return red.MAIN;
    case ReportStatus.IN_PROGRESS:
      return yellow.MAIN;
    default:
      return black;
  }
};
